import React from 'react';
import ReactDOM from 'react-dom';
import LoggedInPage from '../../views/core/LoggedInPage';
import Iframe from 'react-iframe';
import $ from 'jquery';
import '../../css/GetTest.css';
import HmAjax from '../../util/HmAjax';
import Pagination from 'react-ultimate-pagination-material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import BrowserStorageUtil from '../../util/BrowserStorageUtil';

import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';


var prassoView = null;
var isPrassoViewLoaded = false;
var evalAndNavigate = false;
var evalAndSubmit = false;
var isSubmitTriggered = false;
var submittedQnMap = new Object();
var showSolution = false;
var correctAns = false;
var solutionResults = [];
var attemptsLeft;
var allowedAttempts;
var currentAttempt;
var currentQuestionNo;
var totalCorrectAns;
var totalNoQuestions=0;
var testCompleted = false;
var isEvaluationGoing = false;
var currTestQuestionId = null;
var currentSnippetId = null;
var questionAnswerStartTime = null;
var questionAnswerElapsedTime = null;
var timeSpentAction="";
var currentRating = null;

var displayTextObj = {};
var iframeContentDomain = null;//"http://local.retailmath.com:3000/";
//const UltimatePagination = reactUltimatePaginationBasic.default;  	

var trackingQuestionObj = {};
var questionLoadTime = null;
class GetTest extends LoggedInPage {
	
   constructor(props) {
    super(props);
    
    displayTextObj.solutionTitle = this.rb("editor.solutionTitle");
    displayTextObj.answerTitleSingle = "";
    displayTextObj.answerTitlePlural = "";
    displayTextObj.showEditorTooltip = this.rb("editor.showEditorTooltip");
    displayTextObj.hideEditorTooltip = this.rb("editor.hideEditorTooltip");
    displayTextObj.enterAnswerMessage = this.rb("editor.enterAnswerMessage");
   
	//var iframeContentUrl = this.getUrlFor("IFRAME_DOMAIN") + "/prassoapp/20171102/";
    //console.log(this.props.topicInfoObj);
	//console.log("currentQNo="+this.props.topicInfoObj.userTest.currentQNo);
    this.state = {
      pageCurrent: (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentAttempt,
      currentAttempt: (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentAttempt,
      currentQuesNo:(this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentQNo,
      pageTotal: this.props.topicInfoObj.testDetails.questionCount,
      totalQuestions:this.props.topicInfoObj.testDetails.questionCount,
      paginationDisabled:false,
      percentageComplete:0,
      testMode:this.props.topicInfoObj.testDetails.mode,
      questionObj:[],
      questionRendered:false,
      attemptedQuestions:this.props.topicInfoObj.attempts || new Object(),
      questionEvaluated:false,
      showSolution:showSolution,
      testCompleted:testCompleted,
	  submitbtnEnabled:false
    };
    
    this.onPageChange = this.onPageChange.bind(this);
    	    
    this.handleMessage = this.handleMessage.bind(this);
    this.iframeLoaded = this.iframeLoaded.bind(this);
    this.getQuestion = this.getQuestion.bind(this);
    this.modalCloseEvent = this.modalCloseEvent.bind(this);
    this.submitClick = this.submitClick.bind(this);
    this.EvaluateClick = this.EvaluateClick.bind(this);
    this.NextClick = this.NextClick.bind(this);
    this.viewHideSolutionClick = this.viewHideSolutionClick.bind(this);
    this.submitPractice = this.submitPractice.bind(this);
    this.enableQuestionTrackTimer = false;
    this.intervalId = null;
    this.checkImageLoaded = this.checkImageLoaded.bind(this);
    this.trackTestClose = this.trackTestClose.bind(this);
  }
  
  onPageChange(page) {  
    this.setState({pageCurrent:page,paginationDisabled:true});      
    //this.getQuestion();
    timeSpentAction = "Pagination";
    evalAndNavigate = true;
	evalAndSubmit = false;
	
    this.evalAns();
	if (page >= totalNoQuestions) {
		this.setState({submitbtnEnabled:true});
	}
	console.warn("currentpage ",page, " : ",totalNoQuestions);
  } 

   evalAns(){
	   showSolution = false;
	   correctAns = false;
	   solutionResults = undefined;
	   this.setState({showSolution:false});
	   prassoView.postMessage({name:"getUserAnswer"}, iframeContentDomain);
   }
   iframeLoaded(){	   
	   const iframeDOMNode = ReactDOM.findDOMNode(this.container)
	   prassoView = iframeDOMNode.contentWindow;
	  
	   isPrassoViewLoaded = true;
	   if(prassoView){    	
		   prassoView.postMessage({name:"setDisplayText",params:[displayTextObj]}, iframeContentDomain);
		   if(this.state.testMode == 1){	
				//prassoView.enableTestMode();
				prassoView.postMessage({name:"enableTestMode"}, iframeContentDomain);
			}
	   }
	   
	   
	   if(this.state.testMode == 1){
		   this.getQuestion();	
		}
		else{
			//console.log(currentQuestionNo,totalNoQuestions);
			if (currentQuestionNo > totalNoQuestions) {
				this.setState({testCompleted:true});
				this.completeTest(true);
			} else {
				this.getQuestion();	  
			}
		}
   }
   componentDidMount(){		 
	   questionAnswerStartTime = null;
	   questionAnswerElapsedTime = null;
	   this.enableQuestionTrackTimer = false;
	   clearInterval(this.intervalId);
	   this.initiateQuestionPulseTimer();
	   currentRating = null;
	   this.props.onRef(this);
	   //console.log(this.props.topicInfoObj);
	   currentAttempt = (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentAttempt;
	   currentQuestionNo = (this.props.topicInfoObj.testDetails.mode==1) ? 1 : this.props.topicInfoObj.userTest.currentQNo;
	   totalCorrectAns = this.props.topicInfoObj.userTest.totalCorrectAns || 0;
	   totalNoQuestions = this.props.topicInfoObj.userTest.ques.length || 0;
	   attemptsLeft = -1;
	   
	   if(this.state.attemptedQuestions){
		   submittedQnMap = this.state.attemptedQuestions;
	   }
	   iframeContentDomain = this.getUrlFor("IFRAME_DOMAIN");
	   
	   window.addEventListener('message', this.handleMessage, false);
	   
	   const iframeDOMNode = ReactDOM.findDOMNode(this.container)
	   iframeDOMNode.addEventListener('load', this.iframeLoaded);
   }
   compoenentWillMount(){
	   this.props.onRef(undefined);
	   window.removeEventListener('message', this.handleMessage, false);
   }
   initiateQuestionPulseTimer(){
	   	var me = this;
	   	 this.intervalId = setInterval(() => {
	   	 	if(me.enableQuestionTrackTimer){	   	 		
	   	 		me.trackQuestionPulsed();
	   	 	}
	   	 }, 30000);
   }
   trackQuestionPulsed(){
	   try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testDetails.id,
			    "question_id": currTestQuestionId,
			    "attempt_no": this.state.currentAttempt
			}
			this.initiateTrack("question_pulsed",trackObj);
		}catch(e){
		}
   }
   handleMessage(event){	
	   console.log(event.origin+", "+iframeContentDomain);
	  /*if (event.origin !== iframeContentDomain) {
	    console.warn('Invalid origin:', event.origin);
	    return;
	  }*/
	   
	   switch (event.data.name) {
	    case 'renderingCompleted':
	    	this.setState({questionRendered:true,paginationDisabled:false});
	    	
	    	var endTime = new Date().getTime();
	    	var questionloadedTime = -1;
	    	if(questionLoadTime != null){
	    		questionloadedTime = endTime - questionLoadTime;
			}
	    	
	    	var trackingdummyObj = {};
	    	if(trackingQuestionObj !== undefined && typeof trackingQuestionObj === "object"){
				for(var key in trackingQuestionObj){
					trackingdummyObj[key] = trackingQuestionObj[key];
				}
			}
	    	
	    	trackingdummyObj["load_duration"] = questionloadedTime;		
			
			this.initiateTrack("question_loaded",trackingdummyObj);
	    	
			questionloadedTime = null;
			questionLoadTime = null;
			
	    	if(questionAnswerStartTime == null){
	    		questionAnswerStartTime = new Date().getTime();
	    	}
	    	
	    	this.enableQuestionTrackTimer = true;	    	
	    	
	    break;
	    case 'userAnswer':
	    	this.handleUserAnswer(JSON.parse(event.data.params));
	    break;
	    case 'pushedUserAnswer':  // enterkey event    	
	    	if(this.state.testMode == 1){
	    		//if($("#evaluateBtn").hasClass("disabled")===false){	    			
					evalAndNavigate = false;
					evalAndSubmit = false;
					timeSpentAction = "Check";
					this.handleUserAnswer(JSON.parse(event.data.params));
	    		//}
	    	}else{
	    		 if(this.state.questionEvaluated == false && isEvaluationGoing == false){	    			
	    			evalAndNavigate = false;
	    			evalAndSubmit = false;
	    			timeSpentAction = "Check";
	    			isEvaluationGoing = true;
	    			this.handleUserAnswer(JSON.parse(event.data.params));
				}
	    	}  
	    break;
	  }
   }
   handleUserAnswer(userAnswer) {		 
	   	var me = this;
		var userAnswered = userAnswer.userAnswered;
		var userResponse =  userAnswer.userResponse;
		
		var topicInfoObj = this.props.topicInfoObj.userTest.ques[this.state.currentQuesNo-1];
		var testid = this.props.topicInfoObj.testDetails.id;
		var quesType = this.state.questionObj.questionType;
		var currrentAttempt = this.state.currentAttempt;
		var mcqRes = null;
		var fibRes = null;
		
		if(quesType === "mcq"){
			mcqRes = userResponse;
		}else{
			fibRes = userResponse;
		}
		
		me.setState({paginationDisabled:false});
		
		if(userAnswered === false){		
			if(me.state.testMode == 1){			
				
				if(evalAndSubmit){
					isEvaluationGoing = false;
					me.trackTimeSpentInQuestion();
					me.completeTest();
					return;
				}
				
				if(userAnswer.partialAnswer){						
					isSubmitTriggered = false;
				    evalAndNavigate = false;
					evalAndSubmit = false;
					isEvaluationGoing = false;
					return;
				}
				
			}else if(me.state.testMode == 2 && evalAndSubmit){
				me.trackTimeSpentInQuestion();
				isEvaluationGoing = false;
				me.completeTest();
				return;
			}
		}
		
		if(userAnswered === false  && me.state.testMode != 1){
			prassoView.focus();
			isEvaluationGoing = false;
			return;
		}else{
			if(me.state.testMode != 1){
				if(me.state.questionObj.questionType == "mcq"){				
					if (!userResponse.isUserOptionCorrect) {
						me.chooseShowSolution(false,false,solutionResults);
						me.ShowHideSolution();
					}
					else{										
						me.chooseShowSolution(false,false,solutionResults);
						me.ShowHideSolution();
					}
				}
			}
		}
		//console.log(userAnswered,userResponse);
		var callBackSuccess = function(response){
			var data = response;
			var finalResult = true;
			isEvaluationGoing = false;
			var solutionResults = new Object();
			for(var res in data){
				finalResult = finalResult & data[res];
				solutionResults[res] = data[res];
			}
			
			if(me.state.questionObj.questionType == "fib"){	
				showSolution = false;
				correctAns = false;	
				me.setState({showSolution:false});
				me.chooseShowSolution(correctAns,showSolution,solutionResults);
				if(showSolution){
					if(me.state.testMode != 1){
						me.setScrollElement("answers-display");
					}
				}				
			}
			
			try{
				var trackingdummyObj = {};
		    	if(trackingQuestionObj !== undefined && typeof trackingQuestionObj === "object"){
					for(var key in trackingQuestionObj){
						trackingdummyObj[key] = trackingQuestionObj[key];
					}
				}
		    	
		    	trackingdummyObj["result"] = finalResult;
		    	trackingdummyObj["answered"] = (userAnswered === undefined) ? true : userAnswered;
				me.initiateTrack("question_evaluated",trackingdummyObj);
			}catch(e){}
			
			me.postEvaluation(finalResult, userAnswered);
			
		}
		var callBackFailure = function(response){		
			isEvaluationGoing = false;
			console.log("QUESTION_EVALUATE Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}
		this.trackTimeSpentInQuestion();
		var postParams={
			"snippetId":this.state.questionObj.snippetId,
			"testId":testid,
			"questionId":topicInfoObj.id,
			"questionType":quesType,
			"fibResponse":fibRes,
			"mcqResponse":mcqRes,
			"attemptNumber":currrentAttempt,
			"questionNumber":topicInfoObj.qOrder,
			"questionSource":topicInfoObj.source,
			"mode":me.state.testMode
		}
		new HmAjax(this.getUrlFor("QUESTION_EVALUATE"),postParams).put(callBackSuccess,callBackFailure);
   }
   postEvaluation(finalResult, userAnswered){
	   var me = this;
	   var topicInfoObj = this.props.topicInfoObj.userTest.ques[this.state.currentQuesNo-1];
	   var currrentAttempt = this.state.currentAttempt;		
		me.setState({questionEvaluated:true});
		if(me.state.testMode == 1){	
			currentQuestionNo = me.state.pageCurrent;
			me.setState({currentQuesNo:me.state.pageCurrent});
			if(userAnswered == false || userAnswered == "" ){
				delete submittedQnMap[topicInfoObj.id+"-"+currrentAttempt];
				me.setState({attemptedQuestions:submittedQnMap});	
				
			}else{
				submittedQnMap[topicInfoObj.id+"-"+currrentAttempt]=true;
				me.setState({attemptedQuestions:submittedQnMap});					
			}
			
			if(isSubmitTriggered){
				me.showSubmitConfirm();
				isSubmitTriggered = false;			
			}else{
				if(evalAndNavigate){
					me.getQuestion();
				}
				else if(evalAndSubmit){
					me.completeTest();
				}
			}
			
			
		}else{
			
			if(finalResult == true){
				attemptsLeft = -1;
				currentAttempt = 1;
				currentQuestionNo++;
				totalCorrectAns++;	
			}else{
				if (allowedAttempts < 1) {						
					currentAttempt++;
				} else {				
					attemptsLeft--;
					currentAttempt++;
					if (attemptsLeft > 0) {
						//$("#attemptsLeft").html(attemptsLeft.toString());
					} else if (attemptsLeft < 0) {
						attemptsLeft = -1;
						currentAttempt = 1;
						currentQuestionNo++;
					} else {
						//$("#attemptsLeft").html("-");
						attemptsLeft = -1;
						currentAttempt = 1;
						currentQuestionNo++;
					}
				}	
			}
			me.setState({currentAttempt:currentAttempt});
			//console.log(currentQuestionNo,attemptsLeft,currentAttempt);
			if (currentQuestionNo > totalNoQuestions) {		
				me.setState({testCompleted:true});
				me.updateProgress();
				me.completeTest();
				return;
			}
		}		
		me.updateProgress();
   }
   chooseShowSolution(correctAns,showsolution,resultsObj){
	   var me = this;
		if(me.state.testMode != 1){
			
			if(me.state.questionObj.questionType == "fib"){
				//prassoView.showSolution(false,showsolution,resultsObj);
				prassoView.postMessage({name:"showSolution",params:[false,showsolution,resultsObj]}, iframeContentDomain);
			}else{
				//prassoView.showSolution(false,showsolution);
				prassoView.postMessage({name:"showSolution",params:[false,showsolution]}, iframeContentDomain);
			}
			
			me.ShowHideSolution();
		}
	}
   ShowHideSolution(){
		
		if(showSolution){
			//$("#displaySolnStudent").html(btn_hidesolution);
		}else{
			//$("#displaySolnStudent").html(btn_viewsolution);
		}
	}
   setScrollElement(target){
		setTimeout(function(){
			//prassoView.scrollToId(target);
			prassoView.postMessage({name:"scrollToId",params:[target]}, iframeContentDomain);
		}, 500);
   }
   modalCloseEvent(){
	   try{
			window.removeEventListener('message', this.handleMessage, false);
		}catch(e){}
		
		try{
			this.enableQuestionTrackTimer = false;
			clearInterval(this.intervalId);
		}catch(e){}
		try{
			
			timeSpentAction = "Close";
			if(this.isVisible($(".quesDispContainer"))==true){
				this.trackTimeSpentInQuestion();
			}
		}catch(e){}
		
		this.trackTestClose();
		
		try{
			var trackObj = {
					"test_id": this.props.topicInfoObj.testDetails.id,
					"submitted": false
			}		
			this.initiateTrack("test_closed",trackObj);
		}catch(e){}
   }
   trackTestClose(){
	   var me = this;
	   try{
			var postParams = {
				"trackingDefId" : 4,
				"testId" : this.props.topicInfoObj.testDetails.id,
				"endTime" : new Date().getTime()				
			}
			
			
			var callBackSuccess = function(response){
			}
	
			var callBackFailure = function(error){
				console.log("Error in TRACK_TEST_CLOSED");
			}
	
			new HmAjax(this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);
		}catch(e){}
		
   }
   isVisible(element) {
	    var element = $(element);
	    if (element.length > 0 && element.css('visibility') !== 'hidden' && element.css('display') !== 'none') {
	        return true;
	    } else {
	        return false;
	    }
	}
   trackTimeSpentInQuestion(){
	   if(questionAnswerStartTime == null){
			return;
		}
	   
	   try{
		  var endTime = new Date().getTime();
		  questionAnswerElapsedTime = (endTime - questionAnswerStartTime);
		   var postParams = {
				"trackingDefId" : 3,
				"testId" :  this.props.topicInfoObj.testDetails.id,
				"questionId" : currTestQuestionId,
				"snippetId" : currentSnippetId,
				"currQuestAtt" : this.state.currentAttempt,
				"sourceId" : 1,
				"timeSpent" : questionAnswerElapsedTime,
				"startTime" : questionAnswerStartTime,
				"endTime" : endTime,
				"action" : timeSpentAction
			}
			
			var me = this;
			var callBackSuccess = function(response){
			}
	
			var callBackFailure = function(error){
				console.log("Error in TRACK_QUESTION_TIMESPENT");
			}
	
			new HmAjax(this.getUrlFor("TRACK_QUESTION_TIMESPENT"),postParams).post(callBackSuccess,callBackFailure);
			
			questionAnswerStartTime = new Date().getTime();
			this.enableQuestionTrackTimer = false;
	   }
	   catch(e){}
   }
   getQuestion(){
	   isEvaluationGoing = false;
	   // this.setState({paginationDisabled:true,questionRendered:false});
	   this.setState({paginationDisabled:true,questionRendered:false,questionEvaluated:false,currentAttempt:currentAttempt,currentQuesNo:currentQuestionNo,showSolution:false});
	    var me = this;
	    questionAnswerStartTime = null;
	    this.enableQuestionTrackTimer = false;
	    currentRating = null;
	    var topicQuesObj = this.props.topicInfoObj.userTest.ques[currentQuestionNo-1];
		var testid = this.props.topicInfoObj.testDetails.id;
		let getQuestionURL = "";
		allowedAttempts = topicQuesObj.attempts;
		currTestQuestionId  = topicQuesObj.id;
		currentSnippetId = topicQuesObj.qId;
		//console.log("topicQuesObj::",topicQuesObj);
		if (allowedAttempts > 0) {
			//$("#totalAttempts").html(allowedAttempts.toString());
			if (attemptsLeft == -1) {
				attemptsLeft = allowedAttempts - (currentAttempt - 1);
				//$("#attemptsLeft").html(attemptsLeft.toString());
			}
		} else {
			//$("#totalAttempts").html("&infin;");
			//$("#attemptsLeft").html("&infin;");
		}
		
		
		var callBackSuccess = function(response){	
						
			let dataJsonList = response;
			let dataQuestion = dataJsonList;		
			if(me.state.testMode == 1){
				dataQuestion = response.questionContainer;
			}
			me.setState({questionObj:dataQuestion});
			//console.log(dataJsonList.answer);
			prassoView.postMessage({name:"loadQuestion",params:[dataQuestion.question, dataJsonList.answer]}, iframeContentDomain);
			
			me.container.scrollTop = 0;
			me.updateProgress();
			me.checkImageLoaded();
		}

		var callBackFailure = function(response){
			questionLoadTime = null;
			me.setState({paginationDisabled:false});
			console.log("GET_QUESTION Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}
		
		
		if(this.state.testMode == 1){
			getQuestionURL = this.getUrlFor("GET_QUESTION_TEST");
		}else{
			getQuestionURL = this.getUrlFor("GET_QUESTION");
		}
		new HmAjax(getQuestionURL+"?snippetId="+topicQuesObj.qId+"&questionId="+topicQuesObj.id+"&attempt="+this.state.currentAttempt+"&source="+topicQuesObj.source+"&testId="+testid).get(callBackSuccess,callBackFailure);
		
		if(questionLoadTime == null){
			questionLoadTime = new Date().getTime();
		}
		trackingQuestionObj = {
				"test_id": testid,
				"question_id": topicQuesObj.id,
				"attempt_no": this.state.currentAttempt
		}
   }
   submitClick(){
	   var me = this;
	   isSubmitTriggered = true;
	   timeSpentAction = "Submit";
	   var unattemptedQuestionCount = this.state.totalQuestions - Object.keys(submittedQnMap).length;
	   console.log("unattemptedQuestionCount="+unattemptedQuestionCount);
	   /*if(unattemptedQuestionCount > 0){
			this.triggerGetUserAnswer(); 	
		}else{
			this.showSubmitConfirm();
		}	*/
	   this.triggerGetUserAnswer(); 	
   }
   submitPractice(){
	   var testId = this.props.topicInfoObj.testDetails.id;
	   
	   var trackObj = {
				"test_id": testId,
				"submitted": true
		}
		this.initiateTrack("test_closed",trackObj);
	   timeSpentAction = "Submit";
	   this.trackTimeSpentInQuestion();
	   this.trackTestClose();
	   setTimeout(function(){
		   window.location.href="/scorecard/"+testId;
 		},500)
	   
   }
   triggerGetUserAnswer(){
		evalAndNavigate = false;
		evalAndSubmit = false;
		this.evalAns();
   }
   showSubmitConfirm(){
	   var me = this;
	   var unattemptedQuestionCount = this.state.totalQuestions - Object.keys(submittedQnMap).length;
	   var msg = "";
	   if(unattemptedQuestionCount > 0){
		   //msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
		   msg = this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);
	   }else{
		   msg = this.rb("test.confirm.allanswered");
	   }
	   confirmAlert({
	      title: this.rb("test.confirm.wanttosubmit"),
	      message: msg,
	      buttons: [
	        {
	          label: this.rb("alert.ok"),
	          onClick: () => {
	        	isSubmitTriggered = false;
			    evalAndNavigate = false;
				evalAndSubmit = true;
				//me.evalAns();
				me.completeTest();
	          }
	        },
	        {
	          label: this.rb("alert.cancel"),
	          onClick: () => {
	        	  isSubmitTriggered = false;
	          }
	        }
	      ]
	    });	  
   }
   completeTest(isScoreCard=false){	  
	   var me = this;
	  
	   var testId = me.props.topicInfoObj.testDetails.id;
	  
		var callBackSuccess = function(response){	
			prassoView.postMessage({name:"disableInput"}, iframeContentDomain);
			
			if(me.state.testMode == 1 || isScoreCard){
				console.log("testId22="+testId)
				 var trackObj = {
							"test_id": testId,
							"submitted":true
					}
					me.initiateTrack("test_closed",trackObj);
				me.trackTestClose(); 
				window.location.href="/scorecard/"+testId;
			}
		}

		var callBackFailure = function(response){			
			console.log("SUBMIT_TEST Error : ", response);
			//me.setState({  modalContent:me.setTestScreen() });
		}		
		
		var postParams={			
			"testId":testId,
			"time":window.btoa(0), // this is elapsed time if timer available
			"revisionTestId":this.props.revisiontestid,
			"topicSubtopicMapId":this.props.topicsubtopicId
		}
		new HmAjax(this.getUrlFor("SUBMIT_TEST"),postParams).put(callBackSuccess,callBackFailure);
   }
   updateProgress() {	
	   var percentComplete = 0 ;
	   if(this.state.testMode == 1){
		   percentComplete = Math.round(((Object.keys(submittedQnMap).length) / this.state.totalQuestions) * 100);
	   }else{
		   percentComplete = Math.round(((currentQuestionNo-1) / totalNoQuestions) * 100);
	   }
		
		this.setState({percentageComplete:percentComplete});		
	}
   EvaluateClick(){
	    if(isEvaluationGoing == false){
			evalAndNavigate = false;
			evalAndSubmit = false;	
			isEvaluationGoing = true;
			timeSpentAction = "Check";
			this.evalAns();
	    }
   }
   NextClick(){
	   this.getQuestion();
	   timeSpentAction = "Next";
	   this.trackTimeSpentInQuestion();
   }
   viewHideSolutionClick(){
	   showSolution = !showSolution;		
		this.chooseShowSolution(correctAns,showSolution,solutionResults);
		this.setState({showSolution:showSolution});
		if(showSolution){
			this.setScrollElement("solution-display");
		}else{
			this.setScrollElement("question-display");			
		}
		
		this.trackShowHideSolution(showSolution);
		this.checkImageLoaded();
   }
   trackShowHideSolution(showSol){
	   var myaction = "";
	   
		if(showSol == true){
			myaction = "Open";
		}else{
			myaction = "Close";			
		}
		var postParams = {
			trackingDefId: 1,
			testId : this.props.topicInfoObj.testDetails.id,
			questionId : currTestQuestionId,
			snippetId : currentSnippetId,			
			currQuestAtt : this.state.currentAttempt,
			sourceId : 1,
			action : myaction
		}
		
		var me = this;
		var callBackSuccess = function(response){
			
		}

		var callBackFailure = function(error){
			console.log("Error in TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
		
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testDetails.id,
			    "question_id": currTestQuestionId,
			    "item_type": this.getTracker().enums.viewedItemType.solution,
			    "hidden": !showSol
			}
			this.initiateTrack("item_viewed",trackObj);
		}catch(e){
		}
   }

   renderBottomSection(){
	   return(
			   <MuiThemeProvider>
			   <div className="col-12 row nopadding">				
					      
					      {(() => {
							  let remedialApp = BrowserStorageUtil.getStoredItem("remedial");
							  let submitbtnEnabled = this.state.submitbtnEnabled;
					    	 if(this.state.testMode == 1 && !remedialApp){	
								 return(
										 <div className="col-12 row">	
										 <div className="col-12 col-sm-12 col-md-9 text-center">
									      <Pagination
									      currentPage={this.state.currentQuesNo}
									      totalPages={this.state.pageTotal}
									      boundaryPagesRange={1}
									      siblingPagesRange={1}
									      hidePreviousAndNextPageLinks={false}
									      hideFirstAndLastPageLinks={false}
									      hideEllipsis={false}
									      onChange={this.onPageChange}
									      disabled={this.state.paginationDisabled}
									    />
									      </div>
										 
										 <div className="col-12 col-sm-12 col-md-3">
											<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.submitClick}>
											{this.rb("test.submittest")}
									 		</button>
								 		</div>
								 		</div>
								 	)
							 }else if(this.state.testMode == 1 && remedialApp){			
								return(
										<div className="col-12 row">	
										<div className="col-12 text-center">
										 <Pagination
										 
										 pageRangeDisplayed = {0}
										 currentPage={this.state.currentQuesNo}
										 totalPages={this.state.pageTotal}
										 boundaryPagesRange={0}
										 siblingPagesRange={0}
										 className = {"remedialpagination"}
										 hidePreviousAndNextPageLinks={false}
										 hideFirstAndLastPageLinks={true}
										 hideEllipsis={true}
										 onChange={this.onPageChange}
										 disabled={this.state.paginationDisabled}
										 
									   />
										 </div>

										 
										
										<div className="col-12 text-center">
										   <button type="button" className="btn btn-primary mediumBtn" disabled={!this.state.questionRendered || !submitbtnEnabled} onClick={this.submitClick}>
										   {this.rb("test.submittest")}
											</button>
										</div>
										</div>
									)
							}else{
								 if(this.state.questionEvaluated == false){
									 return(
											<div className="col-12 row">	
												<div className="col-12 col-sm-12">											
													 <button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered && !isEvaluationGoing} onClick={this.EvaluateClick}>
													 	{this.rb("test.check")}
											 		</button>	
											 	</div>										 
										 	</div>
									 	)
								 }else{
									 return(
											<div className="col-12 row">	
												<div className="col-12 col-sm-12">		
													{(() => {
										 				if(this.state.testCompleted){
										 					return(
										 						<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.submitPractice}>
										 							{this.rb("test.submit")}
														 		</button>	
										 					);
										 				} else{
										 					return(
										 						<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.NextClick}>
										 							{this.rb("test.next")}
														 		</button>	
										 					);
										 				}											 				
										 			})()}
											 		
											 		<button type="button" className="btn btn-primary mediumBtn float-right" disabled={!this.state.questionRendered} onClick={this.viewHideSolutionClick}>
											 			{(() => {
											 				if(this.state.showSolution){return (<div>{this.rb("test.hidesolution")}</div>)} else{return (<div>{this.rb("test.viewsolution")}</div>)}											 				
											 			})()}											 			
											 		</button>
											 	</div>										 
										 	</div>
									 	)
								 }
								 
							 }
			    		 })()}
					 
				</div>
		     </MuiThemeProvider>
	   );
   }

   updateTotalQuestionDisplay = () => {
		return(
			<div className="totalquestn float-right">
				<span>Total Questions:&nbsp;{totalNoQuestions}</span>
			</div>
		)
   }

   updatePercentageDisplay(){
	   
	   
	   return(
			   <div className="percentageDisp float-right">
			   {(() => {
			    	 if(this.state.testMode == 1){		
						 return(
								 <h5>{this.state.percentageComplete}% {this.rb("test.complete")} </h5>
						 	)
					 }else{						
						 return(
								 <h5>{this.state.percentageComplete}% {this.rb("test.complete")} &nbsp; | &nbsp;{this.rb("test.attemptsleft")}: {(attemptsLeft<0)?0:attemptsLeft} </h5>
						 	)
					 }
			   })()}
			   </div>
	   );
   }
   likeFn(event){
	   if($(event.currentTarget).hasClass("selected")){
		   return false;
	   }
	   const ratingIcons = document.querySelectorAll('.ratingIcon');
	   ratingIcons.forEach(rating => {
		   rating.classList.remove('selected');
	   })
	   event.currentTarget.classList.add("selected");
	   
	   var postParams = {
			trackingDefId: 2,
			testId : this.props.topicInfoObj.testDetails.id,
			questionId : currTestQuestionId,
			snippetId : currentSnippetId,
			rating : parseInt($(event.currentTarget).attr("data-id")), 
			currQuestAtt : this.state.currentAttempt,
			sourceId : 1,
			action : "submit"
		}
		currentRating = parseInt($(event.currentTarget).attr("data-id"));
		var me = this;
		var callBackSuccess = function(response){
			$(".likebox").attr("data-myrating",currentRating);
		}

		var callBackFailure = function(error){
			console.log("Error in TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
		
		
		try{
			var trackObj = {
				"test_id": this.props.topicInfoObj.testDetails.id,
			    "question_id": currTestQuestionId,
			    "attempt_no": this.state.currentAttempt,
			    "helpful": parseInt($(event.currentTarget).attr("data-id")) === 2
			}
			this.initiateTrack("solution_rated",trackObj);
		}catch(e){
		}
		
		
   }
   setRatingSelected(id){
	   if(currentRating != null){
		   if(currentRating == id){
			   return "selected";
		   }
	   }
   }
   renderRatingContainer() {
	   if(this.state.showSolution){
		return (
			<div className="likebox" data-myrating="0">
				<p>{this.rb("rating.title")}</p>
				<div className="btngp">
					<span className={"ratingIcon "+this.setRatingSelected(2)} data-id="2" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_up</i></span>
					<span className={"ratingIcon "+this.setRatingSelected(1)} data-id="1" onClick={this.likeFn.bind(this)}><i className="material-icons">thumb_down</i></span>
				</div>
			</div>
		)
	   }
	}
   checkImageLoaded(){	
		try{
			$('img').unbind("error");
			$('img').error(function(){		
				var me = this;
				var timeDelay = 5000;
				
				if(!$(me).attr('imageReloadCount')){
					$(me).attr('imageReloadCount',1);
				}
				
				timeDelay = timeDelay * parseInt($(me).attr('imageReloadCount'));			
				
				setTimeout(function()
				{ 				
					if(!$(me).attr('imageReloadCount')){
						$(me).attr('imageReloadCount',1);
					}else{
						$(me).attr('imageReloadCount',parseInt($(me).attr('imageReloadCount'))+1);
					}
					
					if($(me).attr('imageReloadCount')<=4){
						//console.log("timeDelay::",timeDelay);
						$(me).attr('src',$(me).attr('src'));
					}
					
					if(console){
						console.log("image not loaded :"+$(me).attr('src'));			
					}
				
				}, timeDelay);		
				
			}).load(function(){
				//console.log("loaded successfully...");
			});
		}
		catch(e){
			
		}
		
	}
  render = () => {
	 
	  return(				
				<div className="row modalBase testTakingScreen">
				
					<div className="col-12 quesDispContainer">
					
						<div className="clearfix">
						
						 <div className="quesNumDisp float-left"><div> Q{this.state.currentQuesNo}</div></div>
							{this.updatePercentageDisplay()}
							{/* {this.updateTotalQuestionDisplay()} */}
							<div className="float-right"><CircularProgressbar percentage={ this.state.percentageComplete}  styles={{
							    path: { stroke: 'rgba(62, 152, 199, ${this.state.percentageComplete / 100})' },
							  }}/></div>
						</div>
						{this.updateTotalQuestionDisplay()}
						<Iframe url={this.getUrlFor("IFRAME_DOMAIN") + "/prassoapp/20171102/"}
							ref = {e => {
					            this.container = e;
					          }}
				            position="relative"
				            id="quesIframe"
				            width="100%"				            
				            className="quesIframe"
				            height="100%"
				            sandbox="allow-scripts allow-same-origin"
				            styles={{height: "63vh"}}						
				            allowFullScreen/>
					</div>
					
					
					{this.renderRatingContainer()}
					
					{this.renderBottomSection()}					
				</div>
		);
  }
}

export default GetTest;



// WEBPACK FOOTER //
// ./src/views/plp/GetTest.js